import { LazyModule, LazyAction, registerLazyOrchestrator } from "owa-bundling";
import type * as lazyIndex from "./lazyIndex";
import { onCoprincipalBootStateChanged } from "owa-account-source-list-store";
import { onCopilotSettingsFetchComplete } from "owa-copilot-settings-store";
import { onAcquisitionsRefreshed } from "owa-m365-acquisitions/lib/lazyFunction";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import("./lazyIndex"), {
    name: "OwaBizChatShared",
});

export const lazyOpenBizChatSidePane: LazyAction<typeof lazyIndex.openBizChatSidePane, typeof lazyModule> = new LazyAction(lazyModule, m => m.openBizChatSidePane);

export const lazyOpenBizChatSidePaneWithAgent: LazyAction<typeof lazyIndex.openBizChatSidePaneWithAgent, typeof lazyModule> = new LazyAction(lazyModule, m => m.openBizChatSidePaneWithAgent);

export const lazyOpenBizChatSidePaneFromDeeplink: LazyAction<typeof lazyIndex.openBizchatSidePaneFromDeeplink, typeof lazyModule> = new LazyAction(lazyModule, m => m.openBizchatSidePaneFromDeeplink);

export const lazyConstructCopilotChatPromptFromText: LazyAction<typeof lazyIndex.constructCopilotChatPromptFromText, typeof lazyModule> = new LazyAction(lazyModule, m => m.constructCopilotChatPromptFromText);

export const lazyGetAgentDetails: LazyAction<typeof lazyIndex.getAgentDetails, typeof lazyModule> = new LazyAction(lazyModule, m => m.getAgentDetails);

export const lazyPrefetchSSRToken: LazyAction<typeof lazyIndex.prefetchSSRToken, typeof lazyModule> = new LazyAction(lazyModule, m => m.prefetchSSRToken);

export { CALENDAR_IMMERSIVE_SEARCH_CMM_ID } from "./utils/ScenarioCMMIds";

export { CALENDAR_AGENT_GPT_ID } from "./utils/agentConstants";

export { getDefaultCalendarAgentType } from "./utils/getDefaultCalendarAgentType";

export { getCalendarAgentId } from "./utils/getCalendarAgentId";

export { isSummaryForConversationsEnabled } from "./utils/isSummaryForConversationsEnabled";

registerLazyOrchestrator(onCoprincipalBootStateChanged, lazyModule, m => m.onCoprincipalAccountChangedOrchestrator);

registerLazyOrchestrator(onCopilotSettingsFetchComplete, lazyModule, m => m.onCopilotSettingsFetchCompleteOrchestrator);

registerLazyOrchestrator(onAcquisitionsRefreshed, lazyModule, m => m.onAcquisitionsRefreshedOrchestrator);
